// extracted by mini-css-extract-plugin
export default {"checkbox":"statuses_checkbox__ZeSyv","main_container":"statuses_main_container__yyT5M"};